/* eslint-disable import/prefer-default-export */
export { default as useSlot } from "./useSlot";
